// extracted by mini-css-extract-plugin
export var subheader = "subheader-module--subheader--x12Kw";